import { apiCall } from './gqlClient';

const ATHLETEWORKOUTPLANS_QUERY = `
  query athleteWorkoutPlans($athleteProfileId: String, $providerId: Float) {
    athleteWorkoutPlans(athleteProfileId: $athleteProfileId, providerId: $providerId)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const athleteWorkoutPlansApiCall = async ({athleteProfileId, providerId}, fragments = null) => apiCall({ query: ATHLETEWORKOUTPLANS_QUERY, variables: {athleteProfileId, providerId}, fragments });

const MYATHLETEWORKOUTPLANS_QUERY = `
  query myAthleteWorkoutPlans {
    myAthleteWorkoutPlans
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const myAthleteWorkoutPlansApiCall = async (fragments = null) => apiCall({ query: MYATHLETEWORKOUTPLANS_QUERY, variables: {}, fragments });

const ATHLETEWORKOUTPLAN_QUERY = `
  query athleteWorkoutPlan($id: String!) {
    athleteWorkoutPlan(id: $id)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const athleteWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: ATHLETEWORKOUTPLAN_QUERY, variables: {id}, fragments });

const ATHLETEPLANPROGRAMMING_QUERY = `
  query athletePlanProgramming($id: String!) {
    athletePlanProgramming(id: $id)
    {
      planId
			programming
      ...fragments
    }
  }`;

export const athletePlanProgrammingApiCall = async ({id}, fragments = null) => apiCall({ query: ATHLETEPLANPROGRAMMING_QUERY, variables: {id}, fragments });

const UPDATEATHLETEWORKOUTPLANSTATUS_QUERY = `
  mutation updateAthleteWorkoutPlanStatus($id: String!, $status: AthleteWorkoutPlanStatus!) {
    updateAthleteWorkoutPlanStatus(id: $id, status: $status)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const updateAthleteWorkoutPlanStatusApiCall = async ({id, status}, fragments = null) => apiCall({ query: UPDATEATHLETEWORKOUTPLANSTATUS_QUERY, variables: {id, status}, fragments });

const SETATHLETEWORKOUTPLANACTIVE_QUERY = `
  mutation setAthleteWorkoutPlanActive($id: String!, $isActive: Boolean!) {
    setAthleteWorkoutPlanActive(id: $id, isActive: $isActive)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const setAthleteWorkoutPlanActiveApiCall = async ({id, isActive}, fragments = null) => apiCall({ query: SETATHLETEWORKOUTPLANACTIVE_QUERY, variables: {id, isActive}, fragments });

const UPDATEATHLETEWORKOUTPLANSCHEDULING_QUERY = `
  mutation updateAthleteWorkoutPlanScheduling($id: String!, $assignedResourceId: Float, $startDate: String, $endDate: String) {
    updateAthleteWorkoutPlanScheduling(id: $id, assignedResourceId: $assignedResourceId, startDate: $startDate, endDate: $endDate)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const updateAthleteWorkoutPlanSchedulingApiCall = async ({id, assignedResourceId, startDate, endDate}, fragments = null) => apiCall({ query: UPDATEATHLETEWORKOUTPLANSCHEDULING_QUERY, variables: {id, assignedResourceId, startDate, endDate}, fragments });

const CREATEPLANFROMTEMPLATE_QUERY = `
  mutation createPlanFromTemplate($templateId: String!, $athleteProfileId: String!, $overrides: JSON) {
    createPlanFromTemplate(templateId: $templateId, athleteProfileId: $athleteProfileId, overrides: $overrides)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const createPlanFromTemplateApiCall = async ({templateId, athleteProfileId, overrides}, fragments = null) => apiCall({ query: CREATEPLANFROMTEMPLATE_QUERY, variables: {templateId, athleteProfileId, overrides}, fragments });

const SELFENROLLINPLAN_QUERY = `
  mutation selfEnrollInPlan($workoutPlanId: String!, $startDate: String, $orderId: Float) {
    selfEnrollInPlan(workoutPlanId: $workoutPlanId, startDate: $startDate, orderId: $orderId)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const selfEnrollInPlanApiCall = async ({workoutPlanId, startDate, orderId}, fragments = null) => apiCall({ query: SELFENROLLINPLAN_QUERY, variables: {workoutPlanId, startDate, orderId}, fragments });

const UPDATEATHLETEWORKOUTPLANPROGRAMMING_QUERY = `
  mutation updateAthleteWorkoutPlanProgramming($id: String!, $programming: JSON!) {
    updateAthleteWorkoutPlanProgramming(id: $id, programming: $programming)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const updateAthleteWorkoutPlanProgrammingApiCall = async ({id, programming}, fragments = null) => apiCall({ query: UPDATEATHLETEWORKOUTPLANPROGRAMMING_QUERY, variables: {id, programming}, fragments });

const UPDATEATHLETEWORKOUTPLANDAY_QUERY = `
  mutation updateAthleteWorkoutPlanDay($id: String!, $week: Float!, $weekday: String!, $dayPatch: JSON!) {
    updateAthleteWorkoutPlanDay(id: $id, week: $week, weekday: $weekday, dayPatch: $dayPatch)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const updateAthleteWorkoutPlanDayApiCall = async ({id, week, weekday, dayPatch}, fragments = null) => apiCall({ query: UPDATEATHLETEWORKOUTPLANDAY_QUERY, variables: {id, week, weekday, dayPatch}, fragments });

const UPDATEATHLETEWORKOUTPLANCOMPOSITION_QUERY = `
  mutation updateAthleteWorkoutPlanComposition($id: String!, $mesocycles: JSON!) {
    updateAthleteWorkoutPlanComposition(id: $id, mesocycles: $mesocycles)
    {
      orphanedSessionIds
      ...fragments
    }
  }`;

export const updateAthleteWorkoutPlanCompositionApiCall = async ({id, mesocycles}, fragments = null) => apiCall({ query: UPDATEATHLETEWORKOUTPLANCOMPOSITION_QUERY, variables: {id, mesocycles}, fragments });

const CREATEATHLETEWORKOUTPLANFROMSCRATCH_QUERY = `
  mutation createAthleteWorkoutPlanFromScratch($athleteProfileId: String!, $title: String, $numberOfWeeks: Float, $tier: String) {
    createAthleteWorkoutPlanFromScratch(athleteProfileId: $athleteProfileId, title: $title, numberOfWeeks: $numberOfWeeks, tier: $tier)
    {
      id
			athleteProfileId
			workoutPlanId
			status
			reviewedAt
			publishedAt
			generation
			programming
			schedule
			nutritionPlanId
			assignedResourceId
			startDate
			endDate
			isActive
			enrollmentSource
			orderId
			createdAt
			updatedAt
			providerId
			title
			description
			imageUrl
			price
			numberOfWeeks
      ...fragments
    }
  }`;

export const createAthleteWorkoutPlanFromScratchApiCall = async ({athleteProfileId, title, numberOfWeeks, tier}, fragments = null) => apiCall({ query: CREATEATHLETEWORKOUTPLANFROMSCRATCH_QUERY, variables: {athleteProfileId, title, numberOfWeeks, tier}, fragments });

const PREVIEWATHLETEPLANPROGRAMMING_QUERY = `
  mutation previewAthletePlanProgramming($id: String!, $programming: JSON!) {
    previewAthletePlanProgramming(id: $id, programming: $programming)
    {
      planId
			programming
      ...fragments
    }
  }`;

export const previewAthletePlanProgrammingApiCall = async ({id, programming}, fragments = null) => apiCall({ query: PREVIEWATHLETEPLANPROGRAMMING_QUERY, variables: {id, programming}, fragments });
